<template>
	<div :class="buttonClasses" v-on:click="createDraftForMeasure()">
		<span :style="buttonLabelStyle">{{ enactButtonLabel }}</span>
		<strong style="font-weight: bold;" v-if="randomAssignmentSuccess">
			(
			<animated-number
				:prev-number="0"
				:key='"erfolg"'
				:number="randomAssignmentSuccess * 100"
				:animation-duration="1"
			></animated-number>
			% Erfolg)
		</strong>
	</div>
</template>

<script>
import AnimatedNumber from "../properties_components/animated_number.vue";
// Other components
import { i18n } from "../utils";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		previewingMeasure: Object,
		currentActorCanCreateDrafts: Boolean,
	},
	components: {
		"animated-number": AnimatedNumber,
	},
	data: function () {
		return {
			processing: false,
			phaseEndsSoon: false,
			enactButtonLabel: "Wähle ein Gesetz aus",
			randomAssignmentSuccess: null,
			buttonClasses: "ulab-button ulab-button-disabled", // TODO add data-for-article-id attr to select correct button. Or pipe through current number of Drafts and Article's max_drafts attr to set disabled here
			buttonLabelStyle: "",
		};
	},
	watch: {
		previewingMeasure: function (newVal, oldVal) {
			this.updateButtonData();
		},
		processing: function (newVal, oldVal) {
			this.updateButtonData();
		},
		randomAssignmentSuccess: function (newVal, oldVal) {
			this.updateButtonData();
		},
	},
	mounted() {
		pp.vue.bus.$on("measure-ENACT", this.onNationalMeasureEnacted);
		pp.gameState.observeChange("endDate", this.setPhaseEndsSoonTimeout);
		setTimeout(() => {
			this.setPhaseEndsSoonTimeout(); // Trigger once just in case
		}, 200);
	},
	beforeDestroy() {
		pp.vue.bus.$off("measure-ENACT", this.onNationalMeasureEnacted);
		pp.gameState.unobserveChange("endDate", this.setPhaseEndsSoonTimeout);
	},
	methods: {
		updateButtonData: function () {
			this.buttonLabelStyle = this.randomAssignmentSuccess
				? "font-weight: normal"
				: "";
			this.buttonClasses = "ulab-button ";
			if (this.processing) {
				// @ts-expect-error
				this.enactButtonLabel = `Gesetz wird ${this.previewingMeasure && this.previewingMeasure.is_national_measure ? "umgesetzt" : "vorgeschlagen"}`;
				this.buttonClasses += "ulab-button-light";
			} else if (this.phaseEndsSoon) {
				this.enactButtonLabel = "Runde wird beendet";
				this.buttonClasses += "ulab-button-disabled";
			} else if (this.previewingMeasure) {
				// @ts-expect-error
				if (this.previewingMeasure.is_national_measure) {
					const affordabilityMsg = this.measureAffordabilityState(); // will be either `true` if affordable or a string that details why the Measure is not affordable
					if (affordabilityMsg == true) {
						this.enactButtonLabel = "Dieses Gesetz beschließen";
						this.buttonClasses +=
							"ulab-button-enact ulab-button-interaction ulab-button-animated-before";
					} else {
						this.enactButtonLabel = affordabilityMsg;
						this.buttonClasses += "ulab-button-forbidden";
					}
				} else {
					if (this.currentActorCanCreateDrafts) {
						this.enactButtonLabel = "Integrationsschritt vorschlagen";
						this.buttonClasses +=
							"ulab-button-enact ulab-button-interaction ulab-button-animated-before";
					} else {
						this.enactButtonLabel = "Nur Ratsvorsitz kann Abstimmungen starten";
						this.buttonClasses += "ulab-button-disabled";
					}
				}
			} else {
				this.enactButtonLabel = "Wähle ein Gesetz aus";
				this.buttonClasses += "ulab-button-disabled";
			}
		},
		measureAffordabilityState: function () {
			const propertiesWithoutMetCondition =
				// @ts-expect-error
				this.previewingMeasure.affordability_conditions
					.map((affordabilityItem) => {
						const conditionType = Object.keys(affordabilityItem)[0];
						if (conditionType != "enacting_actor") {
							return null; // Can only calculate for the calling Actor atm
						}

						const conditionsHash = Object.values(affordabilityItem)[0];
						for (const propKey in conditionsHash) {
							const conditionsForProp = conditionsHash[propKey];
							const apToCompare = VueStore.getters.actorPropertyOfTypeFor(
								pp.currentActorId,
								propKey,
							);
							const comparison = `${apToCompare.values[pp.gameState.phaseId].current_value} ${conditionsForProp.comparison_operator} ${conditionsForProp.comparison_value}`;
							// pp.log("comparison:", comparison)
							if (eval(comparison) == false) {
								return apToCompare.property;
							}
						}
					})
					.filter((item) => {
						return item !== undefined;
					});

			if (propertiesWithoutMetCondition.length) {
				return `Nicht genug ${propertiesWithoutMetCondition[0].names[I18n.locale]}`;
			}
			return true;
		},
		afterCreateDraft() {
			// Do nothing for national Measures (those will be handled in `onNationalMeasureEnacted`)
			pp.log(
				"into afterCreateDraft -- previewing Measure is national?",
				this.previewingMeasure
					? // @ts-expect-error
						this.previewingMeasure.is_national_measure
					: "NO PREV",
			);
			if (
				!this.previewingMeasure ||
				// @ts-expect-error
				!this.previewingMeasure.is_national_measure
			) {
				pp.log("- clearing");
				pp.vue.bus.$emit("choosableMeasuresSelectable", true);
				this.processing = false;
			}
		},
		onNationalMeasureEnacted(res) {
			pp.log("into onNationalMeasureEnacted", res);
			this.randomAssignmentSuccess = res.success_of_random_assignment;
			// Give animations some time to run
			window.setTimeout(() => {
				pp.log("- in timeout");
				this.processing = false;
				this.randomAssignmentSuccess = null;
				pp.vue.bus.$emit("choosableMeasuresSelectable", true);
				VueStore.commit("updatePreviewingMeasure", { measure: null });
			}, 2000);
		},
		createDraftForMeasure() {
			if (
				!this.currentActorCanCreateDrafts ||
				(this.previewingMeasure && this.measureAffordabilityState() != true) ||
				this.phaseEndsSoon
			) {
				return;
			}

			this.processing = true;
			pp.vue.bus.$emit("choosableMeasuresSelectable", false);
			const draftParams = {
				draft: {
					drafts_measures_attributes: {
						// @ts-expect-error
						0: { measure_id: this.previewingMeasure.id },
					},
				},
			};
			// Either find the id of the *sub*-Article for this Actor, or default to the *top*-Article's id (for intl. Measures which are attached directly to the top-Article)
			let articleIdOfMeasure =
				// @ts-expect-error
				this.previewingMeasure.article_ids_per_actor[pp.currentActorId];
			if (articleIdOfMeasure === undefined) {
				articleIdOfMeasure = Object.values(
					// @ts-expect-error
					this.previewingMeasure.article_ids_per_actor,
				)[0];
			}
			$.ajax({
				url: `/articles/${articleIdOfMeasure}/drafts`,
				type: "POST",
				dataType: "script",
				data: draftParams,
			}).always(() => {
				this.afterCreateDraft();
			});
		},
		setPhaseEndsSoonTimeout() {
			if (pp.gameState.endDate === "willBeChanged") {
				pp.log("setPhaseEndsSoonTimeout: willBeChanged");
				return;
			}
			if (this.phaseEndsSoonTimeout) {
				clearTimeout(this.phaseEndsSoonTimeout);
				// @ts-expect-error
				this.phaseEndsSoonTimeout = null;
			}
			const that = this;
			// @ts-expect-error
			this.phaseEndsSoonTimeout = setTimeout(
				() => {
					pp.log("in timeout", pp.gameState.endDate);
					that.phaseEndsSoon = true;
					that.updateButtonData();
				},
				// @ts-expect-error
				pp.gameState.endDate - new Date() - 5000,
			);
		},
	},
};
</script>
